<template>
	<div class="support-con"></div>
</template>
<script>
    export default{}
</script>

<style scoped="">

</style>


// WEBPACK FOOTER //
// src/components/mobile/zh-cn/support.vue